<template>
  <v-card flat
          tile>
    <pre>{{ contact }}</pre>
  </v-card>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true,
    }
  }
}
</script>
